import $ from 'jquery';

const jsContainer = () => {
    var wrapper = $('.entry-header-simulator__image-wrapper');
    if (wrapper.length) {
        const bodyWidth = $('body').outerWidth()

        if (window.matchMedia('(min-width: 992px)').matches) {
            wrapper.css({
                width: `calc(${bodyWidth / 2}px`,
                marginLeft: `calc(${-bodyWidth / 2}px + 100%)`,
            })
        } else {
            wrapper.css({
                width: `calc(${bodyWidth}px`,
                marginLeft: `calc(${-bodyWidth}px + 100%)`,
            })
        }
    }
}

$(window).bind('resize', jsContainer).trigger('resize')

